import React from 'react';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-regular-svg-icons';
import { faMagnifyingGlass, faCartShopping, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { loginObj } from '../multiFunctions';


function MenuDesktop() {
    const aTagStyle = {
      color: "white",
      textDecoration: "none"
    }

    return ( 
    <div style={{height: "65px", backgroundColor: '#0C344B',color: "white", textAlign: "center", justifyContent: "center", display: "flex", width: `100%` }}>
        <div style={{ maxWidth: "1200px", width: "100%" }}>
          <div style={{ display: "flex" }}>
            <a href='/' style={aTagStyle}>
              <img src='./img/companyLogo.png' width="45" height="45" style={{ flex: "auto", padding: "10px", maxHeight: "45px", maxWidth:"45px" }}  alt=""/>
            </a>
            <div style={{ flex: "auto", padding: "5px", fontSize: "large" }}>
              <a href='/membership' style={aTagStyle}>
                <p>Membership</p>
              </a>
            </div>
            <div style={{ flex: "auto", padding: "5px", fontSize: "large" }}>
              <a href='/ourCoffee' style={aTagStyle}>
                <p>Our Coffee</p>
              </a>
            </div>
            {loginObj.isLogged && <div style={{ flex: "auto", paddingTop: "15px", paddingLeft: "25px", fontSize: "xx-large" }}>
              <FontAwesomeIcon icon={faCircleUser}/>
            </div>}

            {loginObj.isLogged && <div>
            <div style={{ flex: "auto", paddingTop: "10px", paddingLeft: "25px", fontSize: "xx-large" }}>
              <Input
                id="searchSite"
                sx={{ 
                  '& .MuiInput-input': { color: "white" }, 
                  '& .MuiInputBase-input': { 
                      backgroundColor: "white", 
                      borderStyle: 'solid',
                      borderRadius: '30px',
                      color: "black" },
                  width: "260px"
                }}
                inputProps={{ style: { paddingLeft: '15px' } }}
                disableUnderline 
                endAdornment={
                  <InputAdornment position="end">
                    <FontAwesomeIcon style={{ color: "white" }} icon={faMagnifyingGlass}/>
                  </InputAdornment>
                }
              />
            </div>
            <div style={{ flex: "auto", paddingTop: "15px", paddingLeft: "25px", fontSize: "xx-large" }}>
              <FontAwesomeIcon icon={faCartShopping}/>
            </div>
            <div style={{ flex: "auto", paddingTop: "15px", paddingLeft: "25px", fontSize: "xx-large" }}>
              <FontAwesomeIcon icon={faGlobe}/>
            </div></div>
            }

          </div>
        </div>
      </div>
    )
}

export default MenuDesktop;